// extracted by mini-css-extract-plugin
export default {"root":"EditItemDropdown_root__+DLLh"};